import { Badge, Flex, Grid, SelectField } from "@aws-amplify/ui-react";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";

import { toolsByCompanyID } from "graphql/queries";

const SelectTool = ({ initialValues, onChangeTools, executor, companyID }) => {
  const [toolSelectedList, setToolSelectedList] = useState([]);
  const [tools, setTools] = useState([]);

  const onDelete = (index) => {
    setToolSelectedList((prevSt) => {
      const listUpdated = [...prevSt];
      listUpdated.splice(index, 1);
      if (onChangeTools) onChangeTools(listUpdated);
      return listUpdated;
    });
  };

  const onSelect = (e) => {
    const { value } = e.target;

    setToolSelectedList((prevSt) => {
      const listUpdated = [...prevSt, value];
      if (onChangeTools) onChangeTools(listUpdated);
      return listUpdated;
    });
  };

  async function fetchTools() {
    try {
      if (!companyID) return;
      const toolsData = await API.graphql(
        graphqlOperation(toolsByCompanyID, {
          companyID,
          filter: {
            or: [
              ...(executor ? [{ technicianID: { eq: executor } }] : []),
              { technicianID: { attributeExists: false } },
              { technicianID: { attributeType: "_null" } },
            ],
            deletedAt: { attributeExists: false },
          },
        })
      );
      const toolsItems = toolsData.data.toolsByCompanyID.items;
      setTools(toolsItems);
    } catch (err) {
      toast.error(strings.responses.errorFetchTools);
    }
  }

  useEffect(() => {
    setToolSelectedList(initialValues ?? []);
  }, [initialValues]);

  useEffect(() => {
    fetchTools();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [executor]);

  return (
    <Grid rowGap="15px">
      <Grid templateColumns={{ base: "1fr" }} rowGap="15px" columnGap="15px">
        <SelectField
          name="tool"
          label={strings.fields.addTool.label}
          onChange={onSelect}
        >
          <option value="">{strings.selectOption}</option>
          {tools
            ?.filter(
              (tool) =>
                !toolSelectedList?.some((toolSel) => toolSel === tool.id)
            )
            .map((tool) => (
              <option key={tool.id} value={tool.id}>
                {tool.name}
              </option>
            ))}
        </SelectField>
      </Grid>
      <Flex rowGap="10px" columnGap="10px" wrap="wrap">
        {toolSelectedList?.map((toolSel, index) => (
          <Badge key={index}>
            {tools?.find((tool) => tool.id === toolSel)?.name}
            &nbsp;
            <CloseIcon
              style={{ cursor: "pointer" }}
              fontSize="inherit"
              onClick={() => onDelete(index)}
            />
          </Badge>
        ))}
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    selectOption: "Seleccione una opción",
    fields: {
      addTool: {
        label: "Agregar Herramienta",
      },
    },
    responses: {
      errorFetchTools: "Error al consultar herramientas",
    },
  },
});

export default SelectTool;
